import { Signal } from "../core/Signal.js";

export class Resize {

    //Disable creation
    private constructor() {

    }

    public static create(element: Element = null): ResizeSignal {
        return new ResizeSignal(element);
    }
}

export class ResizeSignal extends Signal<[Element, DOMRectReadOnly]>{

    private _element: Element = null;

    private static _observer: ResizeObserver = null;

    constructor(element: Element = null) {
        super();

        ResizeSignal.createObserver();
        this.element = element;
    }

    public get element(): Element {
        return this._element;
    }

    public set element(element: Element) {
        if (this._element === element)
            return;
        if (this._element) {
            var before: any = this._element;
            before._resizers.splice(before._resizers.indexOf(this), 1);
            if (before._resizers.length === 0) {
                ResizeSignal._observer.unobserve(this._element);
                before._resizers = undefined;
            }
        }
        this._element = element;
        if (this._element) {
            var after: any = this._element;
            if (!after._resizers) {
                after._resizers = [];
                ResizeSignal._observer.observe(this._element);
            }
            after._resizers.push(this);
        }
    }

    public dispose(): void {
        this.element = null;
        super.dispose();
    }

    private static createObserver(): void {
        if (this._observer)
            return;
        this._observer = new ResizeObserver((entries) => {
            for (var entry of entries) {
                var resizers = (entry.target as any)._resizers as ResizeSignal[];
                for (var resize of resizers) {
                    resize.dispatch(resize.element, entry.contentRect);
                }
            }
        });
    }
}